/**
 * @file 角色码读取 Hook
 * @description 从权限 Store 读取指定项目的角色码列表。
 */

import {useUrlProjectId} from './useUrlProjectId';
import {usePermissionsStore} from '@/store/usePermissionsStore';
import type {ProjectId} from '@/types';

const EMPTY_ROLE_CODES: string[] = [];

/**
 * 获取角色码列表
 * @param projectId 指定项目，不传则取当前所在项目
 * @returns 角色码数组；权限未就绪或非项目上下文时返回空数组
 * @example
 * ```typescript
 * const roleCodes = useRoleCodes();
 * const isWriter = roleCodes.includes('writer');
 * ```
 */
export const useRoleCodes = (projectId?: ProjectId): string[] => {
    const currentProjectId = useUrlProjectId();
    const targetProjectId = projectId ?? currentProjectId;

    return usePermissionsStore(
        (state) =>
            (targetProjectId ? state.roleCodesByProject[targetProjectId] : undefined) ??
            EMPTY_ROLE_CODES,
    );
};
